// client/src/services/userManagementService.js
// This file acts as a generic interface for user management services.
// It currently re-exports functions from supabaseUserManagementService.js.
// To switch user management providers, modify this file to import from a different service.

import supabaseUserManagementService from './supabase/supabaseUserManagementService';

const userManagementService = {
  getAllUserProfiles: supabaseUserManagementService.getAllUserProfiles,
  getCurrentUserProfile: supabaseUserManagementService.getCurrentUserProfile,
  deleteUser: supabaseUserManagementService.deleteUser,
  updateUserTier: supabaseUserManagementService.updateUserTier,
};

export default userManagementService;